import React from 'react'

const NoAccess = () => {
    return (
        <div className='d-flex w-100 justify-content-center align-items-center'>
            No tienes acceso a este módulo.
        </div>
    )
}

export default NoAccess